// @flow
import update from 'immutability-helper';
import { of } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { setNewAlert } from '../../../alert/duck';
import { endpoints, postConfirmationApi } from './api';

import type { HTTPError } from '../../../../error';
import type { Order } from '../../../../entities';
import type { Observable } from 'rxjs';
import analytics from '../../../../analytics';
import type { RootState } from '../../../index';

type InTransitAction = {
  +type: string;
  +error?: HTTPError;
  +order?: Order;
  +orderId?: string;
};

export type InTransitState = {
  +isPostingConfirmation?: boolean;
  +postConfirmationSuccessful?: boolean;
  +postConfirmationError?: HTTPError;
};

// Actions
const IN_TRANSIT_POST_CONFIRMATION_REQUEST = 'IN_TRANSIT_POST_CONFIRMATION_REQUEST';
const IN_TRANSIT_POST_CONFIRMATION_SUCCESS = 'IN_TRANSIT_POST_CONFIRMATION_SUCCESS';
const IN_TRANSIT_POST_CONFIRMATION_ERROR = 'IN_TRANSIT_POST_CONFIRMATION_ERROR';

// Action Creators
export function postConfirmation(orderId: string): InTransitAction {
  return {
    type: IN_TRANSIT_POST_CONFIRMATION_REQUEST,
    orderId,
  };
}

export function postConfirmationSuccess(order: Order): InTransitAction {
  return {
    type: IN_TRANSIT_POST_CONFIRMATION_SUCCESS,
    order,
  };
}

export function postConfirmationErrorFn(error: HTTPError): InTransitAction {
  return {
    type: IN_TRANSIT_POST_CONFIRMATION_ERROR,
    error,
  };
}

export const actions = {
  IN_TRANSIT_POST_CONFIRMATION_REQUEST,
  IN_TRANSIT_POST_CONFIRMATION_SUCCESS,
  IN_TRANSIT_POST_CONFIRMATION_ERROR,
  postConfirmation,
  postConfirmationSuccess,
  postConfirmationErrorFn,
};

export const initialState: InTransitState = {};

// Reducer
export default function reducer(state: InTransitState = initialState,
                                action: InTransitAction): InTransitState {
  switch (action.type) {
    case IN_TRANSIT_POST_CONFIRMATION_REQUEST:
      return update(state, {
        $unset: ['postConfirmationError', 'postConfirmationSuccessful'],
        isPostingConfirmation: { $set: true },
      });
    case IN_TRANSIT_POST_CONFIRMATION_SUCCESS:
      return update(state, {
        $unset: ['isPostingConfirmation'],
        postConfirmationSuccessful: { $set: true },
      });
    case IN_TRANSIT_POST_CONFIRMATION_ERROR:
      return update(state, {
        $unset: ['isPostingConfirmation'],
        postConfirmationError: { $set: action.error },
      });
    default:
      return state;
  }
}

// Epics
export function postConfirmationEpic(action$: Observable<InTransitAction>): Observable<InTransitAction> {
  return action$.pipe(
    ofType(IN_TRANSIT_POST_CONFIRMATION_REQUEST),
    mergeMap(({ orderId }) => postConfirmationApi(undefined, {
        route: endpoints.POST_CONFIRMATION.replace(':orderId', orderId)
      }).pipe(
      mergeMap((order: Order) => of(postConfirmationSuccess(order))),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(postConfirmationErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(postConfirmationErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(postConfirmationErrorFn(e));
      }))
    ));
}



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/in-transit/duck.js